import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Platform } from 'ionic-angular/platform/platform';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoDensitySwitchComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-density-switch',
  templateUrl: 'co-density-switch.html'
})
export class CoDensitySwitchComponent {
  densityButtons: any;
  viewType: string;
  @Output() densityChanged = new EventEmitter<any>();
  @ViewChild('densityButtons') densityButtonsView;
  hideDensityOne: boolean = false;
  constructor(private platform: Platform, public state:AppState) {
    if (this.state.sharedScreen) this.hideDensityOne = true;
    this.hideDensityOne = true;
  }

  ngOnInit() {
    this.densityButtons = this.densityButtonsView.nativeElement.children;
    this.viewType = this.state.mode;
    this.awaitPlatformReady();
  }

  async awaitPlatformReady() {
    await this.platform.ready();
    this.changeDensity(2);
  }

  changeDensity(density: number) {
    //tell parent to change density view
    this.densityChanged.emit(density);
    //update active button
    Array.prototype.forEach.call(this.densityButtons, function(button, i){
      if (`density_${i+1}` != `density_${density}`) {
        button.className = `am-density0${i+1}`
        button.className += " densityIcon";
        button.className += " nonActive";
      } else {
        button.className = `am-density0${density}`
        button.className += " densityIcon";
      }
    })
  };

  backgroundColorCheck(){
    if (this.viewType === "desktop"){
      return false;
    } else {
      return true;
    };
  };


}



// WEBPACK FOOTER //
// ./src/components/co-density-switch/co-density-switch.ts